/*global Modernizr */
/*jslint browser:true */

(function() {
  'use strict';

  var sidebar_menus = document.querySelectorAll('.sidebar');
  if(sidebar_menus) {
    sidebar_menus.forEach((sidebar_menu) => {
      var menu_item_triggers = sidebar_menu.querySelectorAll('.anchor-container.menu-item-depth-1 .anchor-dropdown');

      if(menu_item_triggers) {
        menu_item_triggers.forEach((menu_item_trigger) => {
          var menu_item = menu_item_trigger.parentNode.parentNode;

          if(menu_item.classList.contains('open')) {
            menu_item_trigger.setAttribute('aria-expanded', 'true');
          }

          menu_item_trigger.addEventListener('click', function (e) {
            e.preventDefault();

            if(menu_item.classList.contains('open')) {
              menu_item_trigger.setAttribute('aria-expanded', 'false');
            } else {
              menu_item_trigger.setAttribute('aria-expanded', 'true');
            }

            menu_item.classList.toggle('open');
          });
        });
      }
    });
  }
}());